/* esm.sh - troika-three-text@0.52.4 */
export * from "/*troika-three-text@0.52.4/esnext/troika-three-text.mjs";
